import React, { useState } from 'react'
import { useStore } from 'react-redux'
import { Table } from 'rsuite'
const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} className="table-link">
      <button type="button" className='text-primary' onClick={() => onClick(rowData.id)}>
        {rowData[dataKey]}
      </button>
    </Cell>
  )
}

const SupplyChildVendor = ({ checkedRelatedSupplierRow, isFromExistingMaster = false, onCreateChild }) => {
  const store = useStore().getState()
  const {
    vendor: {
      masterSupplierDetails,
      suppliers
    },
  } = store

  const columns = [
    {
      name: 'suppliername',
      label: 'Supplier Name',
      flexgrow: 1
    },
    {
      name: 'domainName',
      label: 'Domain Name',
      flexgrow: 1
    },
    {
      name: 'companyId',
      label: 'Customer ID',
      flexgrow: 1
    },
    {
      name: 'address_matching_ratio',
      label: 'Address Matching Ratio(%)',
      flexgrow: 2
    },
    {
      name: 'acceptance_match_ratio',
      label: 'Acceptance Match Ratio(%)',
      flexgrow: 2
    },
    {
      name: 'address1',
      label: 'Address',
      flexgrow: 1
    },
    {
      name: 'acceptance_info',
      label: 'Acceptance Info',
      flexgrow: 1
    },
    {
      name: 'conditions',
      label: 'Conditions',
      flexgrow: 1
    },
  ]

  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const data = masterSupplierDetails?.childVendors || [];

  const handleClickRelatedSuppplierData = (value) => {
    let selectedChildSupplier = [];
    selectedChildSupplier = [...selectedChildSupplier, data.find(row => row.id === value)]
    checkedRelatedSupplierRow(selectedChildSupplier)
  }

  const headerElements = columns.map((col, index) => {
    if (index === 0) {
      return (
        <Column
          resizable
          sortable
          key={col.name}
        >
          <HeaderCell>{col.label}</HeaderCell>
          <LinkCell dataKey={col.name} onClick={handleClickRelatedSuppplierData} />
        </Column>
      )
    }
    return (
      <Column
        resizable
        sortable
        key={col.name}
      >
        <HeaderCell>{col.label}</HeaderCell>
        <Cell dataKey={col.name} />
      </Column>
    )
  })

  const paginatedData = data?.sort((a, b) => {
    let x = a[sortColumn];
    let y = b[sortColumn];
    if (typeof x === 'string') {
      x = x.charCodeAt();
    }
    if (typeof y === 'string') {
      y = y.charCodeAt();
    }
    if (sortType === 'asc') {
      return x - y;
    } else {
      return y - x;
    }
  }).slice(limit * (page - 1), limit * page)

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  }

  return (
    <div className="card supply-child-vendor">
      <div className="card-header flex-column flex-sm-row align-items-start align-items-sm-center h-auto gap-2">
        <h3 className='fw-bold'>Child Supplier Details</h3>
        {!isFromExistingMaster && (
          <div role="button" className='ms-auto d-flex gap-2 mb-2'>
            <button
              type="button"
              className="fs-4 text-white rounded ps-5 pe-5 py-3 ps-sm-5 pe-sm-5 bg-dark-blue"
              onClick={onCreateChild}
            >
              Create Child
            </button>
          </div>
        )}
      </div>
      <div className="card-content">
        <Table
          virtualized
          height={500}
          affixHeader={true}
          data={paginatedData}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          loading={loading}
        >
          {headerElements}
        </Table>
        <div className="child-vendor-table-pagination">
          <Pagination
            prev
            next
            first
            last
            maxButtons={5}
            activePage={page}
            showInfo
            layout={['limit', '|', 'pager']}
            displayLength={limit}
            total={data.length}
            lengthMenu={[
              {
                label: '10',
                value: 10,
              },
              {
                label: '20',
                value: 20,
              },
              {
                label: '30',
                value: 30,
              },
              {
                label: '50',
                value: 50,
              },
              {
                label: '100',
                value: 100,
              },
            ]}
            onChangePage={(event) => { setPage(event) }}
            onChangeLength={handleChangeLimit}
          />
        </div>
      </div>
    </div>
  )
}

export default SupplyChildVendor